import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createVoucherApi } from "../../services/vouchers/create.voucher.api";

export const useCreateVoucherApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (infoCreate: any) => createVoucherApi(infoCreate),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["vouchers"],
      });
    },
  });
};
